import { render, staticRenderFns } from "./MoreOrdersList.vue?vue&type=template&id=903dbfac&scoped=true&"
import script from "./MoreOrdersList.vue?vue&type=script&lang=js&"
export * from "./MoreOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./MoreOrdersList.vue?vue&type=style&index=0&id=903dbfac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903dbfac",
  null
  
)

export default component.exports